import { AppNS } from 'app';

import { Box, SxProps } from '@mui/material';

export interface ProjectAddressFormattedProps {
  address: AppNS.Project | AppNS.ProjectAddress;
  commaSeparated?: boolean;
}

const getStyles = (): { [key: string]: SxProps } => {
  return {
    titleCase: {
      textTransform: 'capitalize',
    },
  };
};

export default function ProjectAddressFormatted(props: ProjectAddressFormattedProps) {
  const { address, commaSeparated } = props;

  const styles = getStyles();
  const streetNumber = address?.streetNumber || address.streetNo;
  const unitNumber = address?.unitNumber || address.streetUnitNo;
  const streetNumberSuffix = address?.streetNumberSuffix || address.streetNoSuffix;

  return (
    <>
      {!commaSeparated && (
        <Box sx={styles.titleCase}>
          {streetNumber} {address.streetName} <br />
          {streetNumberSuffix} {streetNumberSuffix && <br />}
          {address.streetType} {address.streetType && <br />}
          {unitNumber} {unitNumber && <br />}
          {address.quadrant} {address.quadrant && <br />}
          {address.zip} {address.zip && <br />}
        </Box>
      )}
      {commaSeparated && (
        <Box sx={styles.titleCase}>
          {`${streetNumber} ${streetNumberSuffix || ''} ${address.streetName} ${address.streetType} ${
            address.quadrant
          } ${(unitNumber && `, ${unitNumber}`) || ''}`}
          {address.zip && <br />}
          {address.zip}
        </Box>
      )}
    </>
  );
}
